import React, { Component } from 'react'
import defaultBcg from '../images/room-1.jpeg'
import Hero from '../components/Hero'
import Banner from '../components/Banner'
import { Link } from 'react-router-dom'
import { MenuContext } from '../context'
import StyledHero from '../components/StyledHero'
export default class SingleMenu extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            slug: this.props.match.params.slug,
            defaultBcg
        };
    }
    static contextType = MenuContext;

    render() {
        const { getMenu } = this.context;
        // will return the selected menu with using getMenu function in context.js
        const menu = getMenu(this.state.slug);
        if (!menu) {
            return <div className="error">
                <h3>I'm sorry the menu you selected is currently not available</h3>
                <Link to='/menu' className="btn-primary">
                    Back To Menu
                </Link>
            </div>
        }
        const { name, description, portion, price, glutenFree, vegeterian, images, extras }
            = menu;
        const [mainImg, ...defaultImg] = images;
        return (
            <>
                <StyledHero img={mainImg || this.state.defaultBcg}>
                    <Banner title={`${name}`} subtitle="*Food may not be same as shown in the picture">
                        <Link to='/menu' className='btn-primary'>
                            back to Menu
                        </Link>
                    </Banner>
                </StyledHero>
                <section className="single-menu">
                    {/* Shown Images */}
                    {/* <div className="single-menu-images">
                        {defaultImg.map((item, index) => {
                            return <img key={index} src={item} alt={name} />;
                        })}
                    </div> */}

                    <div className="single-menu-info">
                        <article className="desc">
                            <h3>details</h3>
                            <p>{description}</p>
                        </article>
                        <article className="info">
                            <h3>info</h3>
                            <h6>price: <b>${price}</b></h6>

                            <h6>
                                portion : {
                                    portion > 1 ? <b>{portion} people</b> : <b>{portion} person</b>
                                }
                            </h6>
                            <h6>{glutenFree ? <b>Gluten Free</b> : <b>Not Gluten Free</b>}</h6>
                            <h6>{vegeterian && <b>Vegterian</b>}</h6>
                        </article>
                    </div>
                </section>
                <section className="room-extras">
                    {extras.length > 0 ? <h6>Options</h6> : ""}
                    <ul className="extras">
                        {extras.map((item, index) => {
                            return <li key={index}>- {item}</li>;
                        })}
                    </ul>
                </section>
            </>
        )
    }
}
